import { Button, Icon, Tooltip } from '@shared/ui';
import type { FC } from 'react';

export interface ShareButtonProps {
  isShared: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const ShareButton: FC<ShareButtonProps> = ({ isShared, onClick, disabled = false }) => {
  if (isShared) {
    return (
      <Tooltip title="Already shared with member">
        <span>
          <Button
            variant="outlined"
            color="gray"
            size="small"
            startIcon={<Icon fontSize="small">group</Icon>}
            disabled
            sx={{ minWidth: 100 }}
          >
            Shared
          </Button>
        </span>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Share with member">
      <span>
        <Button
          variant="contained"
          color="secondary"
          size="small"
          startIcon={<Icon fontSize="small">lock</Icon>}
          onClick={onClick}
          disabled={disabled}
          sx={{ minWidth: 100 }}
        >
          Share
        </Button>
      </span>
    </Tooltip>
  );
};

export default ShareButton;
